import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { GetWarehousesValue, GetWarehousesValueDto, Warehouses } from '../models';
import { WarehouseDto } from '@app/store/shared/models';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getWarehouses(value: GetWarehousesValue): Observable<Warehouses> {
        const params = new GetWarehousesValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<WarehouseDto[]>>('v1/admin/warehouses', { params }).pipe(mapDto((response) => new Warehouses(response)));
    }
}
